import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';
/**
 * 其他-模块
 */

var other = {
  path: '/evolution',
  redirect: '/evolution/detail',
  component: RootLayout,
  children: [{
    path: 'detail',
    name: 'EvolutionDetail',
    component: function component() {
      return import('@/views/evolution');
    },
    meta: {
      title: '任务详情'
    }
  }, {
    path: 'material',
    name: 'EvolutionMaterial',
    component: function component() {
      return import('@/views/evolution/evolutionMaterial');
    },
    meta: {
      title: '进化材料',
      auth: true
    }
  }, {
    path: 'award',
    name: 'EvolutionAward',
    component: function component() {
      return import('@/views/evolution/evolutionAward');
    },
    meta: {
      title: '进化奖励',
      auth: true
    }
  }]
};
export default other;